$(document).ready( function() {

    /**
     * TEXTAREA CHAR COUNTER
     */

    function count(textarea) {
        if(textarea) {
            var txtVal = $(textarea).val();
            var chars = txtVal.length;

            return chars;
        }
        return 0;
    }

    $('textarea.charcount').on('keyup propertychange paste', function () {
        var chars = count(this);
        $(this).next(".charcounter").children(".chars").html(chars)

        if(chars > 0) {
            $(this).next(".charcounter").fadeTo("fast", 1);
        }else {
            $(this).next(".charcounter").fadeTo("fast", 0);
        }
    });

    $('textarea.charcount').each(function () {
        var maxl = $(this).attr("maxlength")
        if(maxl) {

            var chars = count(this);

            $(this).next(".charcounter").children(".chars").html(chars)
            $(this).next(".charcounter").children(".maxcahrs").html(maxl)

            if(chars > 0) {
                $(this).next(".charcounter").fadeTo("fast", 1);
            }
        }
    })


    /**
     * IMAGE VALIDATION
     */

    $("form.file").submit( function( e ) {
        var form = this;
        e.preventDefault(); //Stop the submit for now
        //Replace with your selector to find the file input in your form
        var fileInput = $(this).find("input[type=file]")[0],
            file = fileInput.files && fileInput.files[0];

        if( file ) {
            var img = new Image();

            img.src = window.URL.createObjectURL( file );

            img.onload = function() {
                var width = img.naturalWidth,
                    height = img.naturalHeight;

                window.URL.revokeObjectURL( img.src );

                if( width >= 300 && height >= 300 ) {
                    form.submit();
                }
                else {
                    //fail
                    $("#imagetosmall").fadeIn("fast")
                }
            };
        }
        else { //No file was input or browser doesn't support client side reading
            form.submit();
        }

    });

    $("#edit-portfolio").on("click", function () {
        var formClass = "form-noEdit";
        var form = $("form.form-portfolio")
        var flag = form.hasClass(formClass)

        if(flag){
            form.removeClass(formClass)
            $("#femanager_div_name").hide();
            $("#femanager_field_name").show();
        }else {
            form.addClass(formClass)
            $("#femanager_div_name").show();
            $("#femanager_field_name").hide();
        }
    });
    
    //POWERMAIL CHECKBOX
    $(".powermail_field .pretty").on("click", function () {
        toggleInput($(this).find("input[type=checkbox], input[type=radio]").first())
    })

    function toggleInput (box) {
        if(box.prop('checked')) {
            box.prop('checked', false);
        } else {
            box.prop('checked', true);
        }
    }

    /**
     * HIDE CHECBOX IF OTHER IS ACTIVE ON #sbfPortfolioFilterForm
     */

    $("#sbfPortfolioFilterForm").each(function () {
        var $this = $(this);
        var listview = $this.find("#listview");
        var mapview = $this.find("#mapview");

        listview.on("click", function () {
            toggleCheckbox(listview, mapview);
        });
        mapview.on("click", function () {
            toggleCheckbox(mapview, listview);
        });

    })

    function toggleCheckbox(clicked, other) {
        var hiddenClass = "hideCheck";

        if ($(clicked).is(':checked')) {
            $(other).parents(".form-group").addClass(hiddenClass);
        } else {
            $(other).parents(".form-group").removeClass(hiddenClass);
        }
    }

    $(".input-filter-city > input").keyup(function(){
        var $this = $(this);
        var select = $(".form-group-perimeter");
        var hiddenClass = "hidden-select";

        if($this.val().length == 0) {
            select.addClass(hiddenClass)
        } else {
            select.removeClass(hiddenClass)
        }
    });


});